import type ReadingPaneInfoBarId from "./ReadingPaneInfoBarId";
import { isGlobalFeatureEnabled } from "owa-feature-flags";

export default function initializeInfoBarIdsForItem(): ReadingPaneInfoBarId[] {
    const useConsolidatedSafety = isGlobalFeatureEnabled("rp-messagebar-external");
    
    const infoBarItems: ReadingPaneInfoBarId[] = [
        "unsubscribeInfoBar",
        ...(useConsolidatedSafety
            ? (["consolidatedSafety"] as const)
            : (["externalMessage", "safetyBar"] as const)),
        "infoImportance",
        "infoSensitivity",
        "infoFlagStatus",
        "irmInfoBar",
        "infoMessageSubmitted",
        "agendaMailFeedback",
        "unauthenticatedSender",
        "infoDelegate",
        "infoMeetingAttendeeDoNotForward",
        "infoSMIME",
        "infoSmimeDecodeError",
        "infoSmimeSigned",
        "addinDecryptionTimedOut",
        "addinDecryptionBlocked",
        "addinDecryptionNativeProtectionBlocked",
        "addinDecryptionFailed",
        "addinDecryptionPartialAttachmentFailure",
        "addinDecryptionTakingLonger",
        "addinDecryptionSuccess",
        "addinDecryptionPending",
        "infoItemPartLoadFailure",
        "encryptedMessageInfo",
        "infoLastUserAction",
        "infoReadReceiptRequested",
        "translateInfoBar",
        "infoResend",
        "infoPolicyTag",
        "infoMessageApprovalAndVoting",
        "infoMessageClassification",
        "infoCLPLabel",
        "infoRevocation",
        "latestRecallAttempt",
        "scheduleSendMessage",
        "delaySendMessage",
        "mailMerge",
        "meetingMessageInfo",
    ];
    return infoBarItems;
}
